import React, { useEffect, useState } from 'react';
import Table from '../../components/tables/Table';
import Pagination from '../../components/tables/pagination/Pagination';
import CustomLoading from '../../components/customLoading/CustomLoading';
import { toast } from 'react-toastify';
import { getOldShopEnquiries } from '../../services/enquiries';
import { formatDateTime } from '../../utils/FormatDateTime';

function OldEnquiries() {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const headers = [
        { label: "Time", key: "created_at" },
        { label: "Name", key: "farmer_name" },
        { label: "Phone", key: "farmer_number" },
    ];

    const pageSize = 50;

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const fetchData = async (query) => {
        setLoading(true);
        try {
            let res = await getOldShopEnquiries(query);
            if (res.status === 200) {
                const data = res.data;
                setData(data)
            } else {
                toast.error("Unable to fetch Data");
            }
            setLoading(false);
        } catch (error) {
            console.error("Error:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData("");
    }, []);

    return (<>
        {
            loading ?
                <div className="flex w-full flex-row justify-center my-2">
                    <CustomLoading size={100} />
                </div>
                :
                <div className="mt-2">
                    <Table
                        headers={headers}
                        rows={data?.results?.map((item, index) => (
                            {
                                farmer_name: <p>{item.farmer_name}</p>,
                                created_at: <p>{formatDateTime(item.created_at)}</p>,
                                farmer_number: <p>{item.farmer_mobile}</p>,
                            }))}
                    />
                </div>}
        {/* Table End */}
        {/* Pagination Begin */}
        {
            data.count !== 0 ?
                <Pagination
                    currentPage={currentPage}
                    
                    pageSize={pageSize}
                    totalEntries={data?.count}
                    onPageChange={handlePageChange}
                    data={data}
                    setData={setData}
                /> : <></>
        }
    </>);
}

export default OldEnquiries;